import { render, staticRenderFns } from "./Photographer.vue?vue&type=template&id=a48368e0&scoped=true&"
import script from "./Photographer.vue?vue&type=script&lang=js&"
export * from "./Photographer.vue?vue&type=script&lang=js&"
import style0 from "./Photographer.vue?vue&type=style&index=0&id=a48368e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48368e0",
  null
  
)

export default component.exports